<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Exchange Rate History</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Report</b> /

      <b>Exchange Rate History</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Expired Points
            </h4>

            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="table-responsive">
              <table
                id="exchange_rate_history_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Earn Rate</th>
                    <th>Spend Rate</th>
                    <th>Updated By</th>
                    <th>Date Updated</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in lists" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ list.earn_rate }}</td>
                    <td>{{ list.spend_rate }}</td>
                    <td>{{ list.updated_by }}</td>
                    <td>
                      <span class="spanDateTime">{{ list.created_at }}</span
                      >{{ list.created_at | moment("DD/MM/YYYY") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "exchange-rate-history",
  components: {
    Loading
  },

  data() {
    return {
      lists: [],
      isLoading: false,
      fullPage: true
    };
  },

  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        let result = await axios.get(axios.lpsURL + `/rate/history`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.lists = result.data.rates;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        return
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }
      
      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    setDatatable() {
      $("#exchange_rate_history_tbl").DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
          },
          {
            extend: "pdfHtml5",
          }
        ]
      });
    }
  },

  async created() {
    await this.loadData();
    this.setDatatable();
  }
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
